import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var PulseIcon = createSvgIcon( /*#__PURE__*/_jsx("polyline", {
  points: "3.13 12 6 12 9 5 14 19 17 12 20.88 12",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2.25"
}), 'PulseIcon');